import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {UtilsService} from "../../../../../core/utils/utils.service";
import {ActivatedRoute} from "@angular/router";
import {Auth2Service} from "../../../../../core/services/security/auth2.service";
import {Subscription} from "rxjs/index";
import {Udp_ModeleConditionnementPlat__ProduitDTO} from "../../../../../core/dtos/unite-de-production_modele-conditionnement-plat__produit.dto";
import {ProduitDTO} from "../../../../../core/dtos/produit-dto";
import {DeclinaisonDTO} from "../../../../../core/dtos/declinaison-dto";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DialogMsgSupplier, Paragraphe} from "../../../../../core/suppliers/dialog-msg-supplier";
import {UniteDeProduction__ModeleConditionnementPlatDto} from "../../../../../core/dtos/unite-de-production-modele-conditionnement-plat-dto";
import {GestionUniteProduction__ModeleConditionnementPlatService} from "../../../../../core/services/gestion-unites-productions/unite-production__modele-conditionnement-plat.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../../../core/constants";
import {ModeleImplementationMcpDto} from "../../../../../core/dtos/conditionnement/plat/modele-implementation-mcp-dto";
import {ImplementationModelesConditionnementsPlatsService} from "../../../../../core/services/conditionnements/plat/implementation-modeles-conditionnements-plats.service";
import {UniteDeMesureDTO} from "../../../../../core/dtos/unitedemesure-dto";
import {GenericDatagridService} from "../../../../../core/services/generics/generic-datagrid.service";
import {InstructionDeclinaisonModel} from "../../../../../core/models/gestion-conditionnements/instruction-declinaison";
import {DxDataGridComponent} from "devextreme-angular";
import {ToastService} from "../../../../../core/services/technique/toast.service";
import ModeleConditionnementPlatDeclinaisonDTO
  from "../../../../../core/dtos/conditionnement/modele-conditionnement-plat-declinaison-dto";
import {ModelesConditionnementsPlatsDeclinaisonsService} from "../../../../../core/services/conditionnements/modeles-conditionnements-plats-declinaison.service";
import {combineLatest} from "rxjs";

@Component({
  selector: 'yo-dialog-edit-implementation-modele-conditionnement-produit',
  templateUrl: './dialog-edit-implementation-modele-conditionnement-produit.component.html',
  styleUrls: ['./dialog-edit-implementation-modele-conditionnement-produit.component.scss']
})
export class DialogEditImplementationModeleConditionnementProduitComponent implements OnInit, OnDestroy {

  subscriptionGlobal: Subscription;
  subOpenDialog: Subscription;

  implementation: Udp_ModeleConditionnementPlat__ProduitDTO;
  produit: ProduitDTO;
  isFabrique: boolean;
  declinaisons: DeclinaisonDTO[] = [];
  unitesList: UniteDeMesureDTO[] = [];
  declinaisonsNbUCList: any[] = [];

  poidsUcByDeclinaisons: any[] = [];

  instructionsByDeclinaison: InstructionDeclinaisonModel[] = [];
  uniteAConditionner: UniteDeMesureDTO;

  udpMcpList: UniteDeProduction__ModeleConditionnementPlatDto[] = [];

  modelesConditionnementsPlatDeclinaisons: ModeleConditionnementPlatDeclinaisonDTO[] = [];

  form: FormGroup = new FormGroup({});
  dialogTitle = 'Création d\'une implémentation';

  displayDialog: boolean = false;

  hasIDistri: boolean = false;

  displayFormNonNourri: boolean = false;
  modelLoaded: ModeleImplementationMcpDto;

  @ViewChild("gridInstructions") gridInstructions: DxDataGridComponent;

  associationsList: ModeleImplementationMcpDto[] = [];

  constructor(private utils: UtilsService,
              private route: ActivatedRoute,
              private udpMcpSvc: GestionUniteProduction__ModeleConditionnementPlatService,
              private implMcpSvc: ImplementationModelesConditionnementsPlatsService,
              private authSvc: Auth2Service,
              private gds: GenericDatagridService,
              private mcpdSvc: ModelesConditionnementsPlatsDeclinaisonsService,
              private toastSvc: ToastService) {

  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subscriptionGlobal);
    this.utils.unsubscribe(this.subOpenDialog);
  }

  ngOnInit(): void {
    this.openDialogSubscription();
  }

  routeSubscription = (data: any) => {
    this.produit = data.produitSupplier.produitDTO;
    this.isFabrique = data.produitSupplier.isFabrique;

    this.mcpdSvc.getAllByIdMcp(this.modelLoaded?.mcpId)
      .subscribe(res => {
        this.modelesConditionnementsPlatDeclinaisons = res.resultList;

        const declinaisonsOfCurrentProduct: DeclinaisonDTO[] = this.produit.produitDeclinaisons.map(pd => pd.declinaison);
        this.declinaisons = declinaisonsOfCurrentProduct.filter(dp => this.modelesConditionnementsPlatDeclinaisons.map(m => m.declinaison).some(n2 => n2.id === dp.id));

        this.displayFormNonNourri = this.modelLoaded && this.modelLoaded.mode === "PIECE_NON_PROPORTIONNELLE";
        this.declinaisonsNbUCList = this.modelesConditionnementsPlatDeclinaisons?.length ? this.modelesConditionnementsPlatDeclinaisons.map(o => ({
          declinaison: this.declinaisons.find(d => d.id === o.declinaison.id),
          nbUc: o.nbUc
        })).filter(o => o.declinaison !== undefined) : this.declinaisons.map(d => ({declinaison: d.id, nbUc: 1}));
        this.poidsUcByDeclinaisons = this.modelLoaded?.poidsUcByDeclinaisons?.length ? this.modelLoaded?.poidsUcByDeclinaisons.map(it => ({
          declinaison: it.idDeclinaison,
          poidsUC: it.poidsUC
        })) : this.declinaisons.map(d => ({declinaison: d.id, poidsUC: 1}));

        if (this.modelLoaded && this.modelLoaded.instructions) {
          this.instructionsByDeclinaison = this.modelLoaded.instructions.map(row => {
            return {
              libelle: row.libelle,
              declinaisons: row.declinaisons,
              values: row.values
            } as InstructionDeclinaisonModel;
          });
        }
      });
  }

  changeUdpModel = (e: any) => {
    this.displayFormNonNourri = e.value && e.value.mode && e.value.mode === 'PIECE_NON_PROPORTIONNELLE';
    // this.declinaisons = this.declinaisons.map(m => m.declinaison);
    this.uniteAConditionner = this.unitesList.find(u => u.id === e.value.uniteAConditionner.id );
    this.form.controls['uniteAConditionner'].setValue(this.unitesList.find(u => u.id === e.value.uniteAConditionner.id ));
  };

  openDialogSubscription = () => {
    this.form = new FormGroup({
      udpMcp: new FormControl(null, [Validators.required]),
      remarques: new FormControl(null, [Validators.maxLength(255)]),
      uniteAConditionner: new FormControl(null, [Validators.required])
    });
    this.subOpenDialog = this.implMcpSvc.openDialog$
      .subscribe(response => {
        this.modelLoaded = response.model;
        this.associationsList = response.list;
        const all$ = combineLatest([this.authSvc.hasGestionIDistri$, this.gds.getAll('unitedemesure'),  this.udpMcpSvc.findAll(), this.route.parent.data]);
        this.subscriptionGlobal = all$.subscribe(results => {
          this.hasIDistri = results[0];
          this.unitesList = results[1].resultList;
          this.udpMcpList = results[2].resultList;
          this.routeSubscription(results[3]);
          this.initForm();
          this.displayDialog = true;
        });
      });
  };

  initForm = (): void => {
    const udpMcp = this.modelLoaded ? this.udpMcpList.find(u => u.id === this.modelLoaded.udpMcpId) : null;
    const remarques = this.modelLoaded ? this.modelLoaded.remarques : '';
    let uniteAConditionner = this.modelLoaded ? this.unitesList.find(u => u.id === this.modelLoaded.uniteAConditionnerId) : null;

    if(!uniteAConditionner && this.uniteAConditionner) {
      uniteAConditionner = this.unitesList.find(u => u.id === this.uniteAConditionner.id);
    }

    this.form = new FormGroup({
      udpMcp: new FormControl(udpMcp, [Validators.required]),
      remarques: new FormControl(remarques, [Validators.maxLength(255)]),
      uniteAConditionner: new FormControl(uniteAConditionner, [Validators.required])
    });
  };

  canSave = (): boolean => this.hasIDistri;

  closeDialog = (): void => {
    this.modelLoaded = null;
    this.uniteAConditionner = null;
    this.initForm();
    this.displayDialog = false;
  };

  addRowInstruction = (): void => {
    this.instructionsByDeclinaison.push({ libelle: '',
      valuesByDeclinaison: this.initValuesByDeclinaisonRow(),
      declinaisons: this.declinaisons.map(d => d.id),
      values: this.declinaisons.map(d => 0)
    } as InstructionDeclinaisonModel);
  };

  initValuesByDeclinaisonRow = (): Map<number, number> => {
    const map = new Map<number, number>();
    this.declinaisons.forEach(declinaison => map.set(declinaison.id, 0));
    return map;
  };

  save = (): void => {
    if (this.form.valid) {
      const udpMcp = this.form.controls['udpMcp'].value;
      const remarques = this.form.controls['remarques'].value;
      const uniteAConditionner = this.form.controls['uniteAConditionner'].value;
      const modelToSend: ModeleImplementationMcpDto = new ModeleImplementationMcpDto();
      modelToSend.mcpId = udpMcp.idModeleConditionnementPlat;
      modelToSend.poidsUcByDeclinaisons = this.poidsUcByDeclinaisons.map(o => ({ idDeclinaison: o.declinaison.id, poidsUC: o.poidsUC }) );
      modelToSend.uniteAConditionnerId = uniteAConditionner.id;
      modelToSend.remarques = remarques;
      modelToSend.udpMcpId = udpMcp.id;
      modelToSend.produitId = this.produit.id;
      modelToSend.nbUcByDeclinaisons = this.declinaisonsNbUCList.map(o => ({ idDeclinaison: o.declinaison.id, nbUc: o.nbUc }) );
      modelToSend.instructions = this.instructionsByDeclinaison;
      modelToSend.update = !!this.modelLoaded;

      this.implMcpSvc.save(modelToSend)
        .subscribe(o => {
          this.displayDialog = false;
          this.implMcpSvc.announceModelSaved(o.one, this.modelLoaded !== undefined && this.modelLoaded !== null);
        });
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez compléter le formulaire`);
    }
  };

  deleteRowInstruction = ($event, rowIndex): void => {
    this.instructionsByDeclinaison.splice(rowIndex, 1);
  };

  changeLibelleInstruction = ($event, rowIndex): void => {
    this.instructionsByDeclinaison[rowIndex].libelle = $event.value;
  };

  changeValueInstruction = ($event, rowIndex, columnIdx): void => {
    const value = $event.value;
    this.instructionsByDeclinaison[rowIndex].values[columnIdx] = value;
    this.instructionsByDeclinaison[rowIndex].valuesByDeclinaison.set(this.instructionsByDeclinaison[rowIndex].declinaisons[columnIdx], value);
  };

  changeUniteAConditionner = ($event): void => {
    this.uniteAConditionner = $event.value;
  };

  changeNbUc = ($event, cell): void => {
    const value = $event.value;
    const columnIdx = cell.columnIndex;
    this.declinaisonsNbUCList[columnIdx].nbUc = value;
  };

  changePoidsUc = ($event, cell): void => {
    const value = $event.value;
    const columnIdx = cell.columnIndex;
    this.poidsUcByDeclinaisons[columnIdx].poidsUC = value;
  }

  public help = (): DialogMsgSupplier => {
    const dms = new DialogMsgSupplier();
    dms.title = `Création d'une implémentation d'un modèle de conditionnement plat`;
    dms.logo = 'fa fa-question-circle  yoni-color';
    const p1: Paragraphe = new Paragraphe();
    p1.title = ``;
    p1.lines = [
    ];

    dms.content = {
      intro: ``,
      paragraphes: []
    };

    return dms;
  };

}
